import { WebsiteBlock } from "../../../cores/websitePage/interfaces/WebsiteBlock";

export function findBlockInTree(blocks: WebsiteBlock[], blockId: string): WebsiteBlock | null {
  for (const block of blocks) {
    if (block.id === blockId) return block;
    if (block.type === "columns" && block.columns) {
      for (const col of block.columns) {
        const found = findBlockInTree(col.blocks || [], blockId);
        if (found) return found;
      }
    }
  }
  return null;
}

export function updateBlockInTree(blocks: WebsiteBlock[], updated: WebsiteBlock): WebsiteBlock[] {
  return blocks.map((block) => {
    if (block.id === updated.id) return updated;
    if (block.type === "columns" && block.columns) {
      return {
        ...block,
        columns: block.columns.map((col) => ({
          ...col,
          blocks: updateBlockInTree(col.blocks || [], updated),
        })),
      };
    }
    return block;
  });
}

export function cloneBlockWithNewIds(block: WebsiteBlock): WebsiteBlock {
  const newId = `${block.type}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
  const cloned: WebsiteBlock = { ...block, id: newId };
  if (block.type === "columns" && block.columns) {
    cloned.columns = block.columns.map((col) => ({
      ...col,
      blocks: (col.blocks || []).map(cloneBlockWithNewIds),
    }));
  }
  return cloned;
}

export function deleteBlockInTree(blocks: WebsiteBlock[], blockId: string): WebsiteBlock[] {
  return blocks
    .filter((block) => block.id !== blockId)
    .map((block) => {
      if (block.type === "columns" && block.columns) {
        return {
          ...block,
          columns: block.columns.map((col) => ({
            ...col,
            blocks: deleteBlockInTree(col.blocks || [], blockId),
          })),
        };
      }
      return block;
    });
}
